import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, ButtonProps } from '@mui/material';

export const ExternalLinkButton: React.FC<ButtonProps> = ({ children, sx, href = '', onClick, ...props }) => {
  if (!Capacitor.isNativePlatform()) {
    return (
      <Button
        component={'a'}
        rel="noopener noreferrer"
        href={href}
        variant="outlined"
        endIcon={<OpenInNewIcon />}
        sx={{ height: 'fit-content', ...sx }}
        target="_blank"
        onClick={onClick}
        {...props}
      >
        {children}
      </Button>
    );
  }

  return (
    <Button
      rel="noopener noreferrer"
      variant="outlined"
      endIcon={<OpenInNewIcon />}
      sx={{ height: 'fit-content', ...sx }}
      onClick={event => {
        onClick?.(event);
        void Browser.open({ url: href });
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
